import {
  AmountType,
  Approval,
  Currency,
  DataSource,
  InvoiceStatus,
  Note,
  PaymentStatus,
} from '@shared/services/gql.service';

export interface InvoiceAmounts {
  discount_total: {
    contract_curr: Currency;
    is_vendor_currency_amount: boolean;
    type: AmountType | string;
    value: number;
  };
  discount_total_trial_currency: {
    exchange_rate?: number;
    is_vendor_currency_amount: boolean;
    type: AmountType | string;
    value: number;
  };
  investigator_total: {
    contract_curr: Currency;
    is_vendor_currency_amount: boolean;
    type: AmountType | string;
    value: number;
  };
  investigator_total_trial_currency: {
    exchange_rate?: number;
    is_vendor_currency_amount: boolean;
    type: AmountType | string;
    value: number;
  };
  invoice_total: {
    contract_curr: Currency;
    is_vendor_currency_amount: boolean;
    type: AmountType | string;
    value: number;
  };
  invoice_total_trial_currency: {
    is_vendor_currency_amount: boolean;
    type: AmountType | string;
    value: number;
  };
  pass_thru_total: {
    contract_curr: Currency;
    is_vendor_currency_amount: boolean;
    type: AmountType | string;
    value: number;
  };
  pass_thru_total_trial_currency: {
    exchange_rate?: number;
    is_vendor_currency_amount: boolean;
    type: AmountType | string;
    value: number;
  };
  services_total: {
    contract_curr: Currency;
    is_vendor_currency_amount: boolean;
    type: AmountType | string;
    value: number;
  };
  services_total_trial_currency: {
    exchange_rate?: number;
    is_vendor_currency_amount: boolean;
    type: AmountType | string;
    value: number;
  };
}

export interface InvoiceCard {
  header: string;
  id: string;
  lines: Array<InvoiceCardLine>;
  note: string;
  status: 'Complete' | 'In Process' | 'Up Next';
}

export interface InvoiceCardLine {
  label?: string;
  note?: string;
  status?: string;
  text?: string;
  type: string;
}

export interface InvoiceLineItem {
  amount?: number;
  Amount?: number;
  Description?: string;
  description?: string;
  netAmountIncludingTax?: number;
}

export interface InvoiceModel {
  accrual_period: null | string;
  admin_review_reason?: null | string;
  approvals: Approval[];
  audit_record_create: boolean | null;
  cards: InvoiceCard[];
  data_source_id: DataSource;
  decline_reason: null | string;
  delete_reason: string;
  does_invoice_mappings_match_total: boolean;
  due_date: null | string;
  expense_amounts: InvoiceAmounts;
  has_prepaid: boolean;
  id: string;
  invoice_date: null | string;
  invoice_no: string;
  invoice_status: InvoiceStatus;
  is_deposit: boolean;
  line_items?: InvoiceLineItem[] | null;
  notes: Note[] | null;
  ocr_line_items?: InvoiceLineItem[] | null;
  organization: {
    currency: Currency;
    id: string;
    name: string;
  };
  payment_date: null | string;
  payment_status?: null | PaymentStatus;
  po_reference: null | string;
  previous_services_period?: null | string;
  services_period: null | string;
}

export const INVOICE_STATUSES = {
  STATUS_APPROVED: 'Approved',
  STATUS_DECLINED: 'Declined',
  STATUS_IN_QUEUE: 'In Queue',
  STATUS_PENDING_APPROVAL: 'Pending Approval',
  STATUS_PENDING_REVIEW: 'Pending Review',
} as { [k in InvoiceStatus]: string };
